import { Modal } from 'flowbite-react';
import React, { FunctionComponent } from 'react';

interface Confirmation {
  visible: boolean;
  yes: () => void;
  no: () => void;
  message: string;
}

const AreYouSure: FunctionComponent<Confirmation> = ({ visible, yes, no, message }) => {
  return (
    <Modal show={visible} size="sm" popup={true} position="top-center" onClose={() => no()}>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to delete this {message}?
          </h3>
          <div className="flex justify-center gap-4">
            <button
              data-modal-toggle="popup-modal"
              type="button"
              onClick={() => yes()}
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
            >
              Yes, I'm sure
            </button>
            <button
              data-modal-toggle="popup-modal"
              type="button"
              onClick={() => no()}
              className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            >
              No, cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AreYouSure;
